import axios from "axios";
import ToastMessage from "../../../components/toast";
import { COMPANY_EINS, DEDUCTION_CODES, SET_ERROR, PAY_PERIOD_PROFILES, DEDUCTION_SCHEDULES, ADD_EDIT_DEDUCTION_SETTINGS, DELETE_SCHEDULE } from "../../types";

/**
 * 
 * @param {String} company company Short Name
 * @returns 
 */
export const getCompanyEins = company => {
    return async dispatch => {
        try {
            let eins = await axios.get(`api/deductions/company-eins/${company}`);
            dispatch({
                type: COMPANY_EINS,
                payload: eins.data
            });
        } catch (e) {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });

        };
    };
};

export const getDeductionCodes = (company, einName) => {
    return async dispatch => {
        try {
            let deductionCodes = await axios.get(`api/deductions/deduction-codes/${company}${einName ? "/" + einName : ""}`);
            dispatch({
                type: DEDUCTION_CODES,
                payload: deductionCodes.data
            });
        } catch (e) {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        };
    };
}

export const getPayPeriodProfiles = (company, einName) => {
    return async dispatch => {
        try {
            let payPeriodProfs = await axios.get(`api/deductions/pay-period-profiles/${company}${einName ? "/" + einName : ""}`);
            dispatch({
                type: PAY_PERIOD_PROFILES,
                payload: payPeriodProfs.data
            });
        } catch (e) {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        };

    };
};

export const getDeductionSettings = payload => {
    return async dispatch => {
        try {
            let deductionSettings = await axios.get('api/deductions/deduction-settings', { params: payload });
            dispatch({
                type: DEDUCTION_SCHEDULES,
                payload: deductionSettings.data
            });
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: {
                    error,
                    error: true
                }
            });
        };
    };
};

export const addUpdateSettings = payload => {
    return dispatch => {
        axios.post('api/deductions/deduction-settings', payload).then(res => {
            dispatch({
                type: ADD_EDIT_DEDUCTION_SETTINGS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        });
    };
};

export const deleteSchedule = id => {
    return dispatch => {
        axios.delete(`api/deductions/delete-schedule/${id}`).then(res => {
            dispatch({
                type: DELETE_SCHEDULE,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e,
                    error: true
                }
            });
        });
    };
};

export const runDeductionTool = (companyShortName, _id) => async () => {
    let runner = await axios.get(`api/deductions/run-tool`, { params: { companyShortName, _id } }).then(res => {
        ToastMessage("Schedule run", "success");
    }).catch(er => {
        ToastMessage(er.message, "error");
    });
    return runner;
}

